{
  "title": "Asistente de IA",
  "newChat": "Nuevo chat",
  "untitled": "Sin título",
  "emptyHint": "Pregunta sobre los dispositivos, campos, planes de riego o actividad reciente de tu finca.",
  "placeholder": "Haz una pregunta…",
  "send": "Enviar",
  "spend": "Gastado ${{spent}} de ${{budget}} este mes — quedan ${{remaining}}.",
  "budgetExceeded": "Esta finca alcanzó su presupuesto mensual del asistente de IA.",
  "unavailable": "El asistente de IA no está disponible en este momento.",
  "experimental": "Experimental"
}
